import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FlexibleColumnLayout } from '@fundamental-ngx/core';

@Component({ template: '', standalone: false })
export class FclComponent {
    selectedRow: any;
    MAX_CHARACTERS = 60;
    localLayout: FlexibleColumnLayout = 'OneColumnStartFullScreen';
    loading = false;
    policiesLoading = false;

    isActionSheetOpen = false;

    closeFcl() {
        this.selectedRow = undefined;
        this.localLayout = 'OneColumnStartFullScreen';
    }

    isFclClosed() {
        return this.localLayout === 'OneColumnStartFullScreen';
    }
}
